export default __webpack_public_path__ + "static/media/table.98ca1b54.svg";